<template>
  <PageTable />
</template>

<script>
import PageTable from './components/table'
export default {
  name: 'ecom-sys-amzReportRecord',
  components: { PageTable },
}
</script>
